import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { AssetInvitationType } from '../schemas/asset-invitation-type.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Invite multiple Users to specific products
 * @param request Array of User IDs, their corresponding Product IDs to invite, and the Asset Invitation Type
 * @returns Success object and list of Users that could not be invited
 */
export function postUsersInviteMultiple(
  this: unknown,
  request: {
    id: number;
    productId: number;
    invitationType?: AssetInvitationType;
  }[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).usersUrl}/invite/multiple`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
          body: JSON.stringify(request),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        success: z.boolean(),
        message: z.string(),
        usersNotInvited: z.array(
          z.object({
            assetId: z.number(),
            productId: z.number(),
          })
        ),
        errorCode: z.number().nullable(),
      })
    )
  );
}
